import React from "react";
import PropTypes from "prop-types";

import Dropdown, { DropdownMultiSelect } from "../Dropdown";
import TitledContainer from "../TitledContainer";

import styles from "./TitledMultiDropdown.css";

const TitledMultiDropdown = (props) => {
  const {
    align,
    emptyText,
    inputComponent,
    inputComponentProps,
    isEdit,
    isMultiple,
    isOpen,
    isRequired,
    keyExtractor,
    limit,
    onEdit,
    onSelect,
    selectedKeys,
    selectedValues,
    title,
    valueExtractor,
    values,
  } = props;

  return (
    <TitledContainer
      isEdit={isEdit}
      isEmpty={(selectedValues || selectedKeys).length === 0}
      onEdit={onEdit}
      title={title}
      isEditable
    >
      {values.length > 0 ? (
        <Dropdown
          align={align}
          inputComponent={inputComponent}
          inputComponentProps={{
            limit,
            tags: selectedValues.map(valueExtractor),
            isEdit,
            isRequired,
            ...inputComponentProps,
          }}
          isMultiple={isMultiple}
          isOpen={isOpen}
          keyExtractor={keyExtractor}
          onChange={onSelect}
          selectedKeys={selectedKeys}
          selectedValues={selectedValues}
          valueExtractor={(v) => ({ label: valueExtractor(v) })}
          values={values}
        />
      ) : (
        <div className={styles.emptyText}>{emptyText}</div>
      )}
    </TitledContainer>
  );
};

const dropdownTypes = [PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.element];

TitledMultiDropdown.propTypes = {
  align: PropTypes.oneOf(["left", "right"]),
  title: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType(dropdownTypes)).isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.oneOfType(dropdownTypes)),
  selectedKeys: PropTypes.array, // eslint-disable-line
  emptyText: PropTypes.string,
  limit: PropTypes.number,
  inputComponent: PropTypes.func,
  inputComponentProps: PropTypes.object, // eslint-disable-line
  isEdit: PropTypes.bool,
  isRequired: PropTypes.bool,
  isOpen: PropTypes.bool,
  isMultiple: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  keyExtractor: PropTypes.func,
  valueExtractor: PropTypes.func,
};

TitledMultiDropdown.defaultProps = {
  inputComponentProps: {},
  isOpen: false,
  isMultiple: true,
  selectedValues: [],
  valueExtractor: (v) => v,
  inputComponent: DropdownMultiSelect,
};

export default TitledMultiDropdown;
